// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ep-6";
export var emphasizeQuantity = "_ep-3";
export var flatBottomCorners = "_ep-5";
export var productImage = "_ep-0";
export var quantityContainer = "_ep-2";
export var tooltip = "_ep-1";
export var wrapAndEllipsesOverflow = "_ep-4";